export default "__VITE_ASSET__09edbd66__"